import AccountBoxIcon from '@mui/icons-material/AccountBox'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AssignmentIcon from '@mui/icons-material/Assignment'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner'
import DomainAddIcon from '@mui/icons-material/DomainAdd'
import HomeWorkIcon from '@mui/icons-material/HomeWork'
import MediationIcon from '@mui/icons-material/Mediation'
import PinInvokeIcon from '@mui/icons-material/PinInvoke'

export { generateTabs }

const generateTabs = ({
  canViewActiviteiten,
  canViewSubprocessen,
  hasKlantgegevens,
}: Record<string, boolean>) => {
  const tabs = [
    {
      label: 'Gegevens',
      id: 'gegevens',
      icon: <DocumentScannerIcon />,
    },
  ]

  if (canViewActiviteiten) {
    tabs.push({
      label: 'Activiteiten',
      id: 'activiteiten',
      icon: <PinInvokeIcon />,
    })
  }

  tabs.push({
    label: 'Bijlagen',
    id: 'bijlagen',
    icon: <AttachFileIcon />,
  })

  if (canViewSubprocessen) {
    tabs.push({
      label: 'Subprocessen',
      id: 'subprocessen',
      icon: <AccountTreeIcon />,
    })
  }

  if (hasKlantgegevens) {
    tabs.push({
      label: 'Klantgegevens',
      id: 'klantgegevens',
      icon: <AccountBoxIcon />,
    })
  }

  tabs.push(
    {
      label: 'Disciplines',
      id: 'disciplines',
      icon: <MediationIcon />,
    },
    { label: 'Objecten', id: 'objecten', icon: <HomeWorkIcon /> },
    {
      label: 'Opdrachten',
      id: 'opdrachten',
      icon: <AssignmentIcon />,
    },
    {
      label: 'Projectafhankelijkheden',
      id: 'projectafhankelijkheden',
      icon: <DomainAddIcon />,
    },
  )

  return tabs
}
